package nl.astraeus.wiki.view

import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import kotlinx.html.js.onFocusOutFunction
import kotlinx.html.org.w3c.dom.events.Event
import nl.astraeus.css.properties.*
import nl.astraeus.komp.HtmlBuilder
import nl.astraeus.komp.Komponent
import nl.astraeus.komp.currentElement
import nl.astraeus.wiki.WikiData
import nl.astraeus.wiki.WikiData.currentPage
import nl.astraeus.wiki.WikiData.pageList
import nl.astraeus.wiki.css.Css
import nl.astraeus.wiki.css.Css.defineCss
import nl.astraeus.wiki.css.CssName
import nl.astraeus.wiki.css.SelectedCls
import nl.astraeus.wiki.domain.WikiPageDto
import nl.astraeus.wiki.mainView
import nl.astraeus.wiki.messages.MessageType
import nl.astraeus.wiki.messages.UpdatePageOrderMessage
import nl.astraeus.wiki.messages.UpdatePageTitleMessage
import nl.astraeus.wiki.service.UserService
import nl.astraeus.wiki.ws.sendMessage
import org.w3c.dom.HTMLInputElement

class Menu : Komponent(), CssName {
  private object AddCss : CssName
  private object TitleInputCss : CssName
  private object SelectedMenuCss : CssName

  init {
    defineCss {
      select(TitleInputCss.cls()) {
        fontSize(1.17.em)
        border("none")
        outline("none")
        backgroundColor(hsl(60, 50, 90))
        padding(1.rem)
        position(Position.relative)
        width(19.25.rem)
        top(0.rem)
      }
      select("h3") {
        padding(1.em)
        margin(0.px)
        and(SelectedCls.cls()) {
          //color(hsl(Css.currentStyle.mainFontColor, 25, 50, 0.4))
          backgroundColor(Css.currentStyle.mainBackgroundColor.changeAlpha(0.4))
        }
      }

      select(SelectedMenuCss.cls()) {
        display(Display.grid)
        justifyContent(JustifyContent.spaceBetween)
        gridTemplateColumns(1.fr, 35.px)
      }
      select(AddCss.cls()) {
        marginLeft(0.5.rem)
      }
    }
  }

  var editingPageName: WikiPageDto? = null

  // Generic drag & drop state reused via utility
  private val dndState = DragAndDropState<WikiPageDto>()

  private fun renamePage(page: WikiPageDto) {
    editingPageName = page
    mainView.requestUpdate()
  }

  private fun doneRenamingPage(e: Event) {
    val target = e.target
    if (target is HTMLInputElement) {
      sendMessage(UpdatePageTitleMessage(currentPage!!.id, target.value)) { msg ->
        if (msg.getMessageType() == MessageType.SUCCESS) {
          currentPage?.title = target.value
          for (page in pageList) {
            if (page.id == currentPage?.id) {
              page.title = target.value
            }
          }
        }
        editingPageName = null
        mainView.requestUpdate()
      }
    }
  }

  override fun HtmlBuilder.render() {
    div {
      div {
        div {
          span {
            +"Pages"
          }
          if (UserService.loggedIn) {
            span(AddCss.name) {
              +"+"

              onClickFunction = {
                WikiData.addPage()
              }
            }
          }
          span(AddCss.name) {
            +"Print all pages"  // Print all icon

            onClickFunction = {
              // go back
              mainView.printWikiMode = true
              mainView.allPages.updatePages()
              mainView.requestUpdate()
            }
          }
        }
      }
      hr {}
      div {
        pageList.forEachIndexed { index, page ->
          if (editingPageName == page) {
            input(classes = TitleInputCss.name) {
              value = page.title

              onFocusOutFunction = ::doneRenamingPage

              (currentElement() as? HTMLInputElement)?.focus()
            }
          } else {
            div(SelectedMenuCss.name) {
              h3 {
                +page.title

                if (page.id == currentPage?.id) {
                  classes += SelectedCls.name
                }
                onClickFunction = {
                  if (!dndState.suppressClick) {
                    if (UserService.loggedIn) {
                      if (page.id == currentPage?.id) {
                        renamePage(page)
                      } else {
                        WikiData.loadPage(page.id)
                      }
                    } else {
                      WikiData.loadPage(page.id)
                    }
                  }
                }
              }
              if (page.id == currentPage?.id && UserService.loggedIn) {
                div {
                  span(MainView.RemoveCss.name) {
                    +"x"

                    onClickFunction = {
                      WikiData.removePage(page.id, page.title)
                    }
                  }
                }
              }

              // Enable drag & drop reordering when logged in (generic utility)
              dragAndDropReorder(
                index = index,
                item = page,
                list = pageList,
                state = dndState,
                enabled = UserService.loggedIn,
                requestUpdate = { requestUpdate() },
                onCommit = { ordered ->
                  val pageIds = ordered.map { it.id }
                  val wikiId = WikiData.currentWiki!!.id
                  sendMessage(UpdatePageOrderMessage(wikiId, pageIds)) { msg ->
                    if (msg.getMessageType() == MessageType.SUCCESS) {
                      // ok
                    } else {
                      // ignore for now; UI already updated optimistically
                    }
                  }
                }
              )
            }
          }
        }
      }
    }
  }
}
